<template>
	<el-dialog
	  :title="dataForm.type==3?'共享开发环境-申请运行资源':'专享开发环境-申请运行资源'"
	  :visible.sync="dialogVisible"
	  width="40%">
	   <el-form :model="dataForm" inline ref="dataForm" :inline="false" :rules="rules">
		   <el-form-item label="环境名称" label-width="100px">
		   	  <el-input disabled  v-model="title"></el-input>
		   </el-form-item>
		   <el-form-item label="存续时长" label-width="100px" prop="cunxu">
			   <el-input placeholder="存续时长(1-10)" v-model="dataForm.cunxu" type="number">
				   <template slot="append">年</template>
			   </el-input>
		   </el-form-item>
		   <el-form-item label="" label-width="100px" prop="yunxings">
			   <el-button type="primary" size="small" icon="el-icon-plus" @click="add">添加运行资源</el-button>
		   </el-form-item>
		   <el-form-item v-for="(item,i) in dataForm.yunxings" :key="i" :label="'运行资源' + (i+1)" label-width="100px" prop="yunxings">
			   <div style="width: 100%;">
				   
				    <span style="width: 80px;text-align: right;">
						<span style="color: red;">*</span>
						CPU：
					</span>
				   <el-tag @click="item.suanli=items" :type="item.suanli==items?'':'info'"  v-for="(items,j) in suanliarr" :key="j" style="margin-right: 10px;cursor: pointer;">
					   {{items}}核
				   </el-tag>
			   </div>
			   <div style="width: 100%;">
				   <span style="width: 80px;text-align: right;">
					   <span style="color: red;">*</span>
					   用途：
				   </span>
				   <el-tag @click="item.yongtu=items.value" :type="item.yongtu==items.value?'':'info'" v-for="(items,j) in yongtuarr" :key="j" style="margin-right: 10px;cursor: pointer;">
					   {{items.label}}
				   </el-tag>
			   </div>
			   <el-button type="danger" size="small" style="margin-top: 20px;" @click="dataForm.yunxings.splice(i,1)">移除</el-button>
		   </el-form-item>
		   <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
			   <el-checkbox v-model="checked"></el-checkbox>
			   <a style="margin-left: 5px;" href="https://www.metabiz.com.cn/html/yunxingfuwu.html" target="_blank">我已仔细阅读并接受SasS最终用户协议(点击链接查看协议内容)</a>
		   </div>
		   
		   <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 20px;">
			  
			   <el-button type="success" @click="user_yunxing_save">
			   			   确认申请
			   </el-button>
		   </div>
	   </el-form>
	</el-dialog>
</template>

<script>
	import { user_yunxing_save } from "@/api/huanjing"
	export default {
		data(){
		   return{
			   checked:false,
			   dialogVisible:false,
			   dataForm:{
				   huanjingid:'',//环境id
				   type:3,//3共享 4专享
				   cunxu:'',//存续时长
				   yunxingtype:1,
				   yunxings:[
					   {
						   suanli:'',
						   yongtu:''
					   }
				   ],//运行资源需求
			   },
			   suanliarr:[4,6,8,12,16,24,32,48,64],//算力 即CPU核数
			   yongtuarr:[
				   {value:1,label:"数据库"},
				   {value:2,label:"应用服务器"}
			   ],//用途数组
			   
			   rules:{
				   cunxu:[{ required: true, message: '存续时长不能为空', trigger: 'blur' }],
				   yunxings:[{ required: true, message: '运行资源必填写', trigger: 'blur' }]
			   },
			   
			   title:'',//环境名称
		   }
		},
		watch:{
			["dataForm.cunxu"](e){
				if(e<1){
					this.dataForm.cunxu = 1
				}
				if(e>10){
					this.dataForm.cunxu = 10
				}
			},
			dialogVisible(e){
				if(e==false){
					this.title = ''
					this.dataForm = {
						   huanjingid:'',//环境id
						   type:3,//3共享 4专享
						   cunxu:'',//存续时长
						    yunxingtype:1,
						   yunxings:[
							   {
								   suanli:'',
								   yongtu:''
							   }
						   ],//运行资源需求
					   }
				}
			},
		},
		methods:{
			user_yunxing_save(){
				let that = this;
				if(!that.checked){
					this.$message.error("请勾选协议");
					return;
				}
				that.$refs['dataForm'].validate((valid) => {
					if (valid) {
						let yunxings = that.dataForm.yunxings;
						let is = 1;
						yunxings.forEach(r=>{
							if(!r.suanli || !r.yongtu){
								is = 0;
							}
						})
						if(is==0){
							that.$message.error("CPU或者用途必选");
							return;
						}
						console.log("请求参数",that.dataForm);
						const loading = this.$loading({
						  lock: true,
						  text: '申请中',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
						user_yunxing_save(that.dataForm).then(res=>{
							loading.close();
							that.dialogVisible = false
							that.$message.success("申请成功");
							that.$emit("yunxingsucc",res.data.orderid);
						}).catch(()=>{
							loading.close();
						})
					}
				})
			},
			show(item){
				console.log("item",item);
				this.$nextTick(()=>{
					this.dialogVisible = true
					this.dataForm.huanjingid = item.id
					this.dataForm.type = item.type
					this.title = item.title
				})
			},
			add(){
				this.dataForm.yunxings.push({
					suanli:'',
					yongtu:''
				})
			},
		}
	}
</script>

<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/views/yunxing/index.vue